import { render } from "./CreatePinGroupView.vue?vue&type=template&id=242d2f50&scoped=true"
import script from "./CreatePinGroupView.vue?vue&type=script&lang=js"
export * from "./CreatePinGroupView.vue?vue&type=script&lang=js"

import "./CreatePinGroupView.vue?vue&type=style&index=0&id=242d2f50&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242d2f50"]])

export default __exports__